"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _focus = require("@react-aria/focus");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customRendererPropTypes = _interopRequireDefault(require("../helpers/customRendererPropTypes"));

var _iconCaret = _interopRequireDefault(require("../../../icons/icon-caret.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomDropdownRenderer = function customDropdownRenderer(_ref) {
  var storedValue = _ref.storedValue,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      isValid = _ref.isValid,
      complete = _ref.complete,
      updateValue = _ref.updateValue,
      updatedValue = _ref.updatedValue;
  (0, _react.useEffect)(function () {
    if (updatedValue) {
      eventHandler.onUpdate(updatedValue);
    }
  }, [updatedValue]);
  (0, _react.useEffect)(function () {
    if (storedValue && updatedValue) {
      updateValue(null);
    }
  }, [storedValue]);
  var fieldKey = fieldData.fieldKey,
      label = fieldData.label,
      options = fieldData.options;
  var wrapperClasses = (0, _classnames["default"])({
    'dropdown__wrapper--error': complete && !isValid,
    'dropdown__wrapper--valid': complete && isValid,
    'dropdown__wrapper--default-selection': options[0] && options[0].label
  });
  var errorId = "".concat(fieldKey, "-error");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_focus.FocusRing, {
    focusRingClass: "dropdown__wrapper--focused",
    within: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown__wrapper ".concat(wrapperClasses)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "dropdown__label",
    htmlFor: fieldKey
  }, label), /*#__PURE__*/_react["default"].createElement("select", {
    className: "dropdown dropdown--form",
    id: fieldKey,
    name: fieldKey,
    onChange: function onChange(event) {
      return eventHandler.handleUpdate(event);
    },
    value: storedValue,
    autoComplete: fieldData.autocomplete,
    "aria-describedby": errorId,
    required: fieldData.validation.required
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })), /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
    className: "dropdown__icon"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    id: errorId,
    role: "alert",
    "aria-live": "assertive"
  }, !isValid && complete && /*#__PURE__*/_react["default"].createElement("span", {
    className: "select-input-control__error"
  }, fieldData.validation.message)));
};

CustomDropdownRenderer.propTypes = _objectSpread(_objectSpread({}, _customRendererPropTypes["default"]), {}, {
  updateValue: _propTypes["default"].func,
  updatedValue: _propTypes["default"].string
});
CustomDropdownRenderer.defaultProps = {
  updateValue: null,
  updatedValue: null
};
var _default = CustomDropdownRenderer;
exports["default"] = _default;